export default __webpack_public_path__ + "static/media/logo.8f20a101.svg";